import axios from 'axios';
import queryString from 'query-string';
import jwt_decode from 'jwt-decode'

const axiosClient = axios.create({
    baseURL: process.env.NODE_ENV !== 'production' ? 'http://localhost:5000/api':process.env.REACT_APP_API_URL,
    headers: {
    'Content-Type': 'application/json',
    },
    withCredentials: true,
    paramsSerializer: params => queryString.stringify(params),
});

const checkTokenExpired = token => {
    let currentDate = new Date()
    try {
        const decodedToken = jwt_decode(token)

        return decodedToken?.exp * 1000 < currentDate.getTime()
    } catch (error) {
        return false
    }
}

const refreshToken = async url => {
    try {
        const response = await axios.get(url, { withCredentials: true })
        return response.data.accessToken
    } catch (error) {
        return false
    }
}
let refreshTokenRequest = null;
axiosClient.interceptors.request.use(async (config) => {
    let accessToken = localStorage.getItem('accessToken')

    config.headers.Authorization = 'Bearer ' + accessToken
    
    if(checkTokenExpired(accessToken)) {

        refreshTokenRequest = refreshTokenRequest ? refreshTokenRequest : refreshToken(`${process.env.REACT_APP_API_URL}/auth/refresh-token`)
        const newToken = await refreshTokenRequest

        refreshTokenRequest = null
        localStorage.setItem('accessToken', newToken)
        config.headers.Authorization = 'Bearer ' + newToken
    }

    return config;
})

axiosClient.interceptors.response.use((response) => {
if (response && response.data) {
return response.data;
}
return response;
}, (error) => {
// Handle errors
throw error;
});
export default axiosClient;